export default {
    listagemMapaLeitos: null,
    listagemFiltradaStatus: null,
    opcoesSelect: null,
    listagemFiltrada: null
};
